import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { FORM_HEADING } from 'organisms/AccountPage/AU/Constants/Constants';
import { renderSuggestions } from 'organisms/AddressModel/Presentation/AddressModal'
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

export const BillingAddressTemplate = parms => {
  const {
    biilingSuggestionRef,
    handleSelect,
    ready,
    value,
    suggestions,
    setValue,
    handleInputBilling,
    countryNameInDefaultLang,
    addresses,
    handleChangeBilling,
    showSuggestions,
  } = parms;
  const { data, status } = suggestions;
  const {
    ADDRESS,
    POSTAL_CODE,
  } = FORM_HEADING;  

  return (
    <>
      <div className='address-form-section'>
        <div className='form-container savebilling-address'>
          <form autocomplete='off'>
            <div className='input-container'>
              <input
                data-testid='search-input-address'
                value={value}
                onChange={handleInputBilling}
                disabled={!ready}
                name='addressLine'
                onFocus={() => setValue(value)}
                required
                type='text'
                title={translateWithI18Next(TRANSLATE_MAPPING_KEY.PLEASE_FILL_OUT_THIS_FIELD)}
              />
              <label className='address-label'>{translateWithI18Next(ADDRESS)}*</label>
             {showSuggestions && 
             <ul ref={biilingSuggestionRef} className='address-list'>
             {renderSuggestions({ data, status, handleSelect, countryNameInDefaultLang })}
           </ul>
             } 
            </div>
            <div className='input-container ml5'>
                <input
                  required
                  type='text'
                  name='pinCode'
                  // onKeyDown={event => onKeyPressed(event)}
                  // onKeyPress={event => onKeyPressed(event)}
                  value={addresses?.pinCode}
                  tabIndex='-1'
                  data-testid='pincode-id'
                  onChange={handleChangeBilling}
                />
                <label className='address-label'>{translateWithI18Next(POSTAL_CODE)}*</label>
              </div>
          </form>
        </div>
      </div>
    </>
  );
};
